<template>
  <div>
    <Form style="margin-top: 20px" :model="formItem" :label-width="150" label-position="left" :disabled="loading" >
      <div class="formRow">
        <div class="formCol">
          <FormItem label="绩效编码">
            <Select v-model="formItem.achTypeId" :clearable="true" placeholder="" filterable
            >
              <Option
                :value="item.id"
                v-for="item in achTypeLabel"
                :key="item.id"
                >{{ item.evaCode }}</Option
              >
            </Select>
          </FormItem>
        </div>
        <div class="formCol">
          <FormItem label="绩效类型">
            <Select
              v-model="formItem.achTypeCode"
              :clearable="true"
              placeholder=""
              filterable>
              <Option
                :value="item.code"
                v-for="item in achTypeMaster"
                :key="item.code"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>
        <div class="formCol">
          <Button @click="(total = 0), (pageInfo.pageNo = 1), getData()"><!-- 检 索 -->{{$t('Search')}}</Button>
        </div>
      </div>
    </Form>
    <Table
      highlight-row
      border
      :columns="columns"
      :data="data"
      :loading="loading"
    >
      <template slot-scope="{ row, index }" slot="action3">
        <Button
          icon="md-create"
          type="warning"
          size="small"
          style="margin-right: 8px"
          @click="editBtn(row, index)"
          >编辑</Button
        >
        <Button
          icon="md-trash"
          type="error"
          size="small"
          @click="deleteBtn(row, index)"
          >删除</Button
        >
      </template>
    </Table>
    <div style="margin: 20px 0">
      <Page
        style="margin-top: 20px; text-align: left"
        :total="total"
        @on-change="pageChange"
        :disabled="loading"
      />
      <Button
        style="float: right"
        icon="md-add"
        type="primary"
        @click="addBtn()"
        :disabled="loading"
        >新增</Button
      >
    </div>
    <Modal
      v-model="openEdit"
      :title="operation == 1 ? '新增' : '编辑'"
      width="500px"
    >
      <div class="center" style="padding: 0 40px">
        <Form :label-width="140" label-position="left">
          <FormItem label="绩效编码">
            <Select
              v-model="formulaItem.achTypeId"
              :clearable="true"
              placeholder=""
              filterable
              @on-change="getAchTypeList(formulaItem.achTypeId)"
            >
              <Option
                :value="item.id"
                v-for="item in achTypeLabel"
                :key="item.id"
                >{{ item.evaCode }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="绩效类型">
            <Select
              v-model="formulaItem.achTypeCode"
              :clearable="true"
              placeholder=""
              filterable
            >
              <Option
                :value="item.code"
                v-for="item in achStatusLabel"
                :key="item.code"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="自评得分占比">
            <Select
              v-model="formulaItem.selfScore"
              :clearable="true"
              placeholder=""
              filterable
            >
              <Option
                :value="item.code"
                v-for="item in scoreLabel"
                :key="item.code"
                >{{ item.name1 }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="他评得分占比">
            <Select
              v-model="formulaItem.otherScore"
              :clearable="true"
              placeholder=""
              filterable
            >
              <Option
                :value="item.code"
                v-for="item in scoreLabel"
                :key="item.code"
                >{{ item.code }}</Option
              >
            </Select>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="confirmSave">保存</Button>
      </div>
    </Modal>
  </div>
</template>
  
  <script>
import axios from "axios";
export default {
  data() {
    return {
      formItem: {},
      columns: [
        {
          title: "绩效编码",
          key: "achTypeId",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            var name = "";
            this.achTypeLabel
              ? this.achTypeLabel.map((item) => {
                  if (item.id == params.row.achTypeId) {
                    name = item.evaCode;
                  }
                })
              : "";
            return h("span", name);
          },
        },
        {
          title: "绩效类型",
          key: "achTypeCode",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            var name = "";
            this.achTypeMaster
              ? this.achTypeMaster.map((item) => {
                  if (item.code == params.row.achTypeCode) {
                    name = item.name;
                  }
                })
              : "";
            return h("span", name);
          },
        },
        {
          title: "自评得分占比",
          key: "selfScore",
          align: "center",
          minWidth: 120,
        },
        {
          title: "他评得分占比",
          key: "otherScore",
          align: "center",
          minWidth: 120,
        },
        {
          title: "操作",
          key: "performanceIndicators",
          slot: "action3",
          align: "center",
          minWidth: 200,
        },
      ],
      data: [],
      loading: false,
      formulaItem: {},
      clickDisabled: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      openEdit: false,
      achTypeLabel: [],
      achStatusLabel: [],
      scoreLabel: [],
      achTypeMaster: [],
      operation: null,
    };
  },
  created() {
    this.getLabel();
    this.getData();
  },
  methods: {
    getAchTypeList(id) {
      let obj = {
        id: id,
      };
      axios.post("/AchFormulaSet/slectAchTypeList", obj).then((res) => {
        if (res) {
          this.achStatusLabel = res;
        } else {
          this.achStatusLabel = [];
        }
      });
    },
    addBtn() {
      this.openEdit = true;
      this.operation = 1;
      this.formulaItem = {};
    },
    editBtn(row, index) {
      this.operation = 2;
      let obj = {
        id: row.achTypeId,
      };
      this.formulaItem = JSON.parse(JSON.stringify(row))//{ ...row };
      axios.post("/AchFormulaSet/slectAchTypeList", obj).then((res) => {
        if (res) {
          this.achStatusLabel = res;
        } else {
          this.achStatusLabel = [];
        }
      });
      this.formulaItem.selfScore = JSON.stringify(this.formulaItem.selfScore)
      this.formulaItem.otherScore = JSON.stringify(this.formulaItem.otherScore)
      this.openEdit = true;
    },
    deleteBtn(row, index) {
      this.$Modal.confirm({
        title: this.$notice("deletion"),
        content: "",
        onOk: () => {
          let obj = {
            id: row.id,
          };
          this.loading = true;
          axios.post("/AchFormulaSet/deleteAchFormulaSet", obj).then((res) => {
            if (res) {
              this.getData();
              setTimeout(() => {
                this.$Message.success("删除成功");
              }, 1000);
              this.openEdit = false;
            }
            this.loading = false;
          });
        },
      });
    },
    confirmSave() {
      let obj = {
        ...this.formulaItem,
        cteateUserId: this.operation == 1 ? JSON.parse(sessionStorage.getItem("userInfo")).userId : null,
        updateUserId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
      };
      if (this.operation == 1) {
        axios.post("/AchFormulaSet/insertAchFormulaSet", obj).then((res) => {
          if (res) {
            this.getData();
            this.openEdit = false;
          }
        });
      } else if (this.operation == 2) {
        axios.post("/AchFormulaSet/updateAchFormulaSet", obj).then((res) => {
          if (res) {
            this.getData();
            this.openEdit = false;
          }
        });
        console.log(this.formulaItem,'formulaItembaocun')
      }
    },
    getLabel() {
      axios.post("/AchFormulaSet/slectAchFormulaSetLabel", {}).then((res) => {
        this.achTypeLabel = res.achTypeList;
        this.scoreLabel = res.scoreFormula;
        this.achTypeMaster = res.achTypeMaster;
      });
    },
    getData() {
      this.loading = true;
      let obj = {
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        achTypeId: this.formItem.achTypeId,
        achTypeCode: this.formItem.achTypeCode,
      };
      axios.post("/AchFormulaSet/slectAchFormulaSet", obj).then((res) => {
        this.data = res.data;
        this.loading = false;
      });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.search();
    },
  },
};
</script>
  
  <style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
  /* margin-right: 30px; */
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 40px) / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/AchFormulaSet.vue